import { colors } from '@material-ui/core'

const INTERNAL_KIND_ID = 1
const EXTERNAL_KIND_ID = 2
const RESTRICTED_KIND_ID = 4

const INTERNAL_KIND_LABEL = 'Interno'
const EXTERNAL_KIND_LABEL = 'Externo'
const RESTRICTED_KIND_LABEL = 'Restrito'

const ORGANIZATION_SOURCE_TYPE = 'organization_source'
const SYSTEM_SOURCE_TYPE = 'system_source'
const REQUESTER_SOURCE_TYPE = 'requester_source'
const COMPANY_SOURCE_TYPE = 'company_source'

const ORGANIZATION_SOURCE_TYPE_LABEL = 'Organização'
const SYSTEM_SOURCE_TYPE_LABEL = 'Sistema'
const REQUESTER_SOURCE_TYPE_LABEL = 'Solicitante'
const COMPANY_SOURCE_TYPE_LABEL = 'Empresa'

const TRANSLATE_KINDS = {
  [INTERNAL_KIND_ID]: INTERNAL_KIND_LABEL,
  [EXTERNAL_KIND_ID]: EXTERNAL_KIND_LABEL,
  [RESTRICTED_KIND_ID]: RESTRICTED_KIND_LABEL,
}

const BOX_MESSAGE_COLOR_BY_SOURCE_TYPE = {
  [SYSTEM_SOURCE_TYPE]: colors.grey[200],
  [REQUESTER_SOURCE_TYPE]: colors.cyan[50],
}

const BOX_MESSAGE_COLOR_BY_KIND = {
  [INTERNAL_KIND_ID]: colors.orange[50],
  [EXTERNAL_KIND_ID]: colors.blue[50],
  [RESTRICTED_KIND_ID]: colors.lightGreen[50],
}

const MESSAGE_TYPE_ICON_COLOR_BY_SOURCE_TYPE = {
  [SYSTEM_SOURCE_TYPE]: colors.grey[800],
  [REQUESTER_SOURCE_TYPE]: colors.cyan[800],
}

const MESSAGE_TYPE_ICON_COLOR_BY_KIND = {
  [INTERNAL_KIND_ID]: colors.orange[700],
  [EXTERNAL_KIND_ID]: colors.blue[700],
  [RESTRICTED_KIND_ID]: colors.lightGreen[700],
}

const TRANSLATE_SOURCE_TYPES = {
  [ORGANIZATION_SOURCE_TYPE]: ORGANIZATION_SOURCE_TYPE_LABEL,
  [SYSTEM_SOURCE_TYPE]: SYSTEM_SOURCE_TYPE_LABEL,
  [REQUESTER_SOURCE_TYPE]: REQUESTER_SOURCE_TYPE_LABEL,
  [COMPANY_SOURCE_TYPE]: COMPANY_SOURCE_TYPE_LABEL,
}

export default {
  BOX_MESSAGE_COLOR_BY_KIND,
  BOX_MESSAGE_COLOR_BY_SOURCE_TYPE,
  COMPANY_SOURCE_TYPE,
  EXTERNAL_KIND_ID,
  INTERNAL_KIND_ID,
  MESSAGE_TYPE_ICON_COLOR_BY_KIND,
  MESSAGE_TYPE_ICON_COLOR_BY_SOURCE_TYPE,
  ORGANIZATION_SOURCE_TYPE,
  REQUESTER_SOURCE_TYPE,
  RESTRICTED_KIND_ID,
  SYSTEM_SOURCE_TYPE,
  TRANSLATE_KINDS,
  TRANSLATE_SOURCE_TYPES,
}
